import { Component } from "preact";
import { formatNumber } from "../../utils";
import style from "./style.css";

const pageSizes = [10, 20, 30, 40, 50];

const formatTodollar = (item) => {
  var prefix = "$";
  if (item < 0) {
    prefix = "-$";
  }
  item = Math.abs(item);
  return prefix + item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

class Table extends Component {
  render() {
    const {
      columns,
      data,
      page,
      pageSize,
      count,
      onPageChange,
      onPageSizeChange,
      onClickRow,
    } = this.props;
    console.log(page);
    return (
      <div>
        <div className={style.tableWrapper}>
          <table>
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={`column_${column.key}`}>{column.value}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={`row_${index}`} onClick={() => onClickRow(item)}>
                  {columns.map((column) => (
                    <td key={`row_${index}_${column.key}`}>
                      {typeof item[column.key] == "number"
                        ? formatTodollar(item[column.key])
                        : item[column.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {onPageChange ? (
          <div className={style.paginationWrapper}>
            <div className={style.contWrapper}>
              <span>
                Total number of elements<b>{count}</b>
              </span>
            </div>
            <div className={style.pageSizeWrapper}>
              <select
                value={pageSize}
                onChange={(event) => onPageSizeChange(event.target.value)}
              >
                {pageSizes.map((size) => (
                  <option
                    key={`page_size_${size}`}
                    selected={size === pageSize}
                    value={size}
                  >
                    {size}
                  </option>
                ))}
              </select>
            </div>
            <div className={style.navigationWrapper}>
              {page > 1 ? (
                <div onClick={() => onPageChange(page - 1)}>
                  <i className="fas fa-chevron-left" />
                </div>
              ) : (
                <div className={style.paginationDisabled}>
                  <i className="fas fa-chevron-left" />
                </div>
              )}
              <span>{page}</span>
              {page * pageSize < count ? (
                <div onClick={() => onPageChange(page + 1)}>
                  <i className="fas fa-chevron-right" />
                </div>
              ) : (
                <div className={style.paginationDisabled}>
                  <i className="fas fa-chevron-right" />
                </div>
              )}
            </div>
          </div>
        ) : undefined}
      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./components/table/index.js